/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
  DownloadOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import { Col, Image, Row, Skeleton, Space, Tooltip } from "antd";
import { capitalize } from "lodash";
import React, { useState } from "react";
import useLang from "../../../../hooks/useLang";
import DocumentIcon from "../../../../icons/js/DocumentIcon";
import { formatBytes } from "../../../../library/utils";
import { heicToJpg } from "../../../../utils";
import { mediaDownloader } from "../../../../utils/mediaDownloader";
import "./image.css";
import MediaViewer from "./mediaViewer";
import MultipleMediaViewer from "./multipleMediaViewer";
import { ViewMediaPopup } from "./ViewMediaPopup";

const MultipleMediaView = props => {
  const { direction, messageDetails, media } = props;

  const [lang] = useLang();

  const [multipleFileModal, setmultipleFileModal] = useState(false);
  const [isModalOpen, setisModalOpen] = useState({
    visible: false,
    selectedMedia: null,
  });
  const [pdfModal, setpdfModal] = useState({
    visible: false,
    pdfUrl: "",
    mediaType: "",
  });
  const handleMediaUI = mediaInfo => {
    const mediaUI = (mediaFile, open = true, single = false) => {
      if (mediaFile.mediaType.includes("image") || mediaFile.mediaType.includes("gif")) {
        const mediaUrl = mediaFile?.compressedMediaUrl || mediaFile?.mediaUrl || "";
        return (
          <div className={`relative ${single && "text-center"}`}>
            <Image
              src={heicToJpg(mediaFile.compressedMediaUrl || mediaFile.mediaUrl)}
              className={`${
                !single && "sm:w-[150px] sm:h-[150px] w-[75px] h-[75px]"
              } cursor-pointer aspect-video ${
                single ? "sm:object-fill object-contain w-full h-full " : "object-contain"
              }`}
              alt=""
              loading="lazy"
              placeholder={
                <Skeleton.Image className={`${!single && "w-[150px] h-[150px]"}`} active />
              }
            />
            {/* <AntdIconV4
              onClick={() => {
                mediaDownloader(mediaFile.mediaUrl, mediaFile?.mediaType?.split("/")[1]);
              }}
              type="DownloadOutlined"
              className="bg-[#000] text-white right-1 top-1 text-[31px] absolute rounded-[5px]"
            /> */}
          </div>
        );
      } else if (mediaFile.mediaType.includes("video")) {
        const mediaUrl = mediaFile?.compressedMediaUrl || mediaFile?.mediaUrl || "";
        return (
          <video
            src={mediaFile.compressedMediaUrl || mediaFile.mediaUrl}
            poster={mediaFile.compressedThumbnail || mediaFile.thumbnailUrl}
            className={`${!single && "w-[150px] h-[150px]"} -mt-[15px] cursor-pointer aspect-video`}
            onClick={() =>
              setisModalOpen({
                ...isModalOpen,
                visible: true,
                selectedMedia: mediaFile,
              })
            }
            controls
          >
            <source src={mediaUrl} type="video/mp4" />
          </video>
        );
      }
    };
    if (mediaInfo?.mediaType?.includes("image") || mediaInfo?.mediaType?.includes("video")) {
      const filteredMedias = media.filter(item => !item.mediaType.includes("application"));
      return (
        <div className="relative py-2">
          <Image.PreviewGroup
            preview={{
              toolbarRender: (
                _,
                {
                  transform: { scale },
                  actions: { onFlipY, onFlipX, onRotateLeft, onRotateRight, onZoomOut, onZoomIn },
                  current,
                }
              ) => (
                <Space size={12} className="toolbar-wrapper">
                  <DownloadOutlined
                    onClick={() =>
                      mediaDownloader(
                        filteredMedias[current].mediaUrl,
                        filteredMedias[current]?.mediaType?.split("/")[1]
                      )
                    }
                  />
                  <SwapOutlined rotate={90} onClick={onFlipY} />
                  <SwapOutlined onClick={onFlipX} />
                  <RotateLeftOutlined onClick={onRotateLeft} />
                  <RotateRightOutlined onClick={onRotateRight} />
                  <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
                  <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
                </Space>
              ),
            }}
          >
            {filteredMedias.length === 1 ? (
              <div className="w-full h-full">{mediaUI(filteredMedias[0], false, true)}</div>
            ) : filteredMedias.length === 2 ? (
              <Row gutter={8}>
                <Col span={12}>{mediaUI(filteredMedias[0])}</Col>
                <Col span={12}>{mediaUI(filteredMedias[1])}</Col>
              </Row>
            ) : filteredMedias.length === 3 ? (
              <Row gutter={8}>
                <Col span={8}>{mediaUI(filteredMedias[0])}</Col>
                <Col span={8}>{mediaUI(filteredMedias[1])}</Col>
                <Col span={8}>{mediaUI(filteredMedias[2])}</Col>
              </Row>
            ) : filteredMedias.length > 2 ? (
              <>
                <Row gutter={8}>
                  <Col span={12}>{mediaUI(filteredMedias[0])}</Col>
                  <Col span={12}>{mediaUI(filteredMedias[1])}</Col>
                </Row>
                <Row>
                  <Col span={filteredMedias.length > 2 ? 12 : 24}>{mediaUI(filteredMedias[2])}</Col>
                  {filteredMedias.length > 3 && (
                    <Col span={12}>
                      <div
                        className="relative text-center text-white cursor-pointer"
                        // onClick={() => setmultipleFileModal(true)}
                      >
                        <div className="wrap">{mediaUI(filteredMedias[3], false)}</div>
                        {filteredMedias.length > 4 && (
                          <div
                            className="absolute top-[50%] left-[50%]"
                            style={{
                              transform: "translate(-50%,-50%)",
                            }}
                          >
                            <p className="text-[20px]">+{filteredMedias.length - 3}</p>
                          </div>
                        )}
                      </div>
                    </Col>
                  )}
                </Row>
              </>
            ) : (
              ""
            )}
            {/* Hidden images for preview */}
            {media.slice(4).map((item, index) => (
              <div key={index + 4} style={{ display: "none" }}>
                {mediaUI(item)}
              </div>
            ))}
          </Image.PreviewGroup>
          <div className="flex-col-centered items-start mt-1 gap-2">
            {media
              .filter(item => item.mediaType.includes("application"))
              .map((item, index) => (
                <PDFRender key={index} item={item} index={index} />
              ))}
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex flex-col items-start gap-2">
          {media.map((item, index) => (
            <PDFRender key={index} item={item} index={index} />
          ))}
        </div>
      );
    }
  };
  return (
    <div
      className={`flex items-end ${direction === "TO_LEAD" ? "justify-end" : "justify-start"}  p-0`}
    >
      <div className="flex flex-col">
        <Image.PreviewGroup>
          {media && media.length > 0 && handleMediaUI(media[0])}
        </Image.PreviewGroup>
      </div>
      {multipleFileModal && (
        <MultipleMediaViewer
          isModalOpen={multipleFileModal}
          handleCancel={() => setmultipleFileModal(false)}
          media={media[0]}
          allMedia={media}
          messageDetails={messageDetails}
        />
      )}
      {isModalOpen.visible && (
        <MediaViewer
          isModalOpen={isModalOpen.visible}
          handleCancel={() => setisModalOpen({ ...isModalOpen, visible: false })}
          media={isModalOpen.selectedMedia}
          messageDetails={messageDetails}
        />
      )}
      {pdfModal.visible && <ViewMediaPopup pdfModal={pdfModal} setpdfModal={setpdfModal} />}
    </div>
  );
};

export default MultipleMediaView;
export function PDFRender({ index, item }) {
  const [pdfModal, setpdfModal] = useState({
    visible: false,
    pdfUrl: "",
    mediaType: "",
  });
  return (
    <div
      key={index}
      className="p-3 flex-row-centered items-center gap-2 bg-white rounded-[4px] w-full"
    >
      <DocumentIcon />
      <div className="flex-col-centered items-start gap-1">
        <Tooltip title="View PDF">
          <span
            onClick={() => {
              if (item.mediaType.split("/")[1] === "pdf") {
                setpdfModal({
                  visible: true,
                  pdfUrl: item.mediaUrl,
                  mediaType: item.mediaType.split("/")[1],
                });
              }
            }}
            className="text-sm text-grey-700 font-[400] cursor-pointer"
          >
            {item?.mediaUrl?.substring(item?.mediaUrl?.lastIndexOf("/") + 1)}
          </span>
        </Tooltip>
        <span className="flex-row-centered gap-[9px]">
          <span className="text-xs font-[400] text-grey-500">{formatBytes(item.size)}</span>
          <div className="w-[1px] h-2.5 bg-grey-500" />
          <Tooltip title={`Download ${capitalize(item.mediaType.split("/")[1])}`}>
            <span
              onClick={() => mediaDownloader(item.mediaUrl, item.mediaType.split("/")[1])}
              className="text-xs font-[600] text-brand-500 cursor-pointer"
            >
              Download
            </span>
          </Tooltip>
        </span>
      </div>
      {pdfModal.visible && <ViewMediaPopup pdfModal={pdfModal} setpdfModal={setpdfModal} />}
    </div>
  );
}
